import { render, staticRenderFns } from "./ProofOfDeliveryDetails.vue?vue&type=template&id=b8cdde08&"
import script from "./ProofOfDeliveryDetails.vue?vue&type=script&lang=js&"
export * from "./ProofOfDeliveryDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProofOfDeliveryDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports